/**
 * The editor VSM experiment (Conductor, ADR-0010): creates the editor VSM engine, swaps the editor's CSS from
 * catharsis to the signals CSS engine, converts every registered editor feature (the platform surface
 * included) from Carmi to VSM, and makes the editor model and the by-ref `DsSetters` write VSM only.
 */
export const VSM_EDITOR_EXPERIMENT = 'vsmEditor' as const
